import { devicesConnectionsLedColors } from '../../util';
import { IColor } from './ColorSelectDropdown.types';

export const isColorCircleActive = (
  circleColorToCheck: string,
  selectedColor: IColor
) => {
  // if currently checking color is build in color (null) or selected color os build in color (null)
  if (
    devicesConnectionsLedColors[circleColorToCheck] ===
      devicesConnectionsLedColors.default ||
    selectedColor.Color === devicesConnectionsLedColors.default
  ) {
    return (
      selectedColor.Color === devicesConnectionsLedColors[circleColorToCheck]
    );
  }

  // otherwise check if currently checking color of standard color circle is same like selected color
  return (
    selectedColor.Color.hue ===
      devicesConnectionsLedColors[circleColorToCheck].hue &&
    selectedColor.Color.saturation ===
      devicesConnectionsLedColors[circleColorToCheck].saturation
  );
};

export const isBuildInColor = selectedColor =>
  devicesConnectionsLedColors[selectedColor] ===
  devicesConnectionsLedColors.default;

export default {
  isColorCircleActive,
  isBuildInColor
};
